module.exports = __webpack_public_path__ + "img/Household-Ergo-Pillows-and-Towel-Icon.89ff6011.png";